import React from "react";

import { ExpertSupportCTAV2 } from "@trailhead/chat";

import { SmartSetupContent, SmartSetupLayout } from "../components";
import {
  ExpertSupportContentContainer,
  createExpertSupport,
  useContentfulData,
} from "@trailhead/contentful";
import { useMxContext } from "@trailhead/mx-context";
import { useQueryParams } from "@trailhead/smart-setup-core";

export const VerizonSmartSetup: React.FC = () => {
  const { client, language } = useMxContext();
  const queryParams = useQueryParams();

  const expertSupportContentQuery =
    useContentfulData<ExpertSupportContentContainer>(
      "expertSupportContentCard",
      client,
      language,
      queryParams.get("isPreview"),
      { "fields.id": "expertSupportVerizonSmartSetup" },
    );

  const ctaProp = {
    offsetCta: true,
    canHideCta: true,
    cta: (
      <ExpertSupportCTAV2
        content={
          expertSupportContentQuery.isLoading
            ? undefined
            : createExpertSupport(expertSupportContentQuery.data)
        }
        extraProps={{
          offsetTopSection: true,
          headerProps: {
            weight: "feather",
          },
          lottieStyleProps: "position: relative; top: 3px;",
        }}
      />
    ),
  };

  return (
    <SmartSetupLayout
      content={<SmartSetupContent cta={ctaProp.cta} />}
      {...ctaProp}
    />
  );
};
